const b64 = input => {
    return btoa(input);
};
export const safe = input => input.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
export default input => safe(b64(input));
